import React from "react";
import PropTypes from "prop-types";
import { Form, Text } from "informed";
import { connect } from "react-redux";
import { validateEmail } from "validators/validators";
import { FormattedMessage, injectIntl } from "react-intl";
import RFEAlert from "../../../components/EYTopNavBar/assets/RFE-alert.svg";

import "../../rfetheme.scss";
import { selectValidLink } from "AuthorizeLink/selectors";

const mapStateToProps = state => {
  return {
    validLink: selectValidLink(state)
  };
};

class MagicLinkAuthentication extends React.Component {
  static propTypes = {
    actionData: PropTypes.object,
    validLink: PropTypes.object,
    handleValidate: PropTypes.func,
    intl: PropTypes.object
  };
  constructor(props) {
    super(props);
  }
  /**Triggers form submit */
  handleValidate = event => {
    event.preventDefault();
    this.formApi.submitForm();

    if (!this.formApi.getState().invalid) {
      this.props.handleValidate(this.formApi.getValue("email"));
    }
  };

  handleEmailValidation = (value, intl) =>
  {
    const result = validateEmail(value, intl);
    if (result !== null)
      return result;
  }

  /**Returns background image */
  SetBackgroundImage = path => {
    return { backgroundImage: "url(" + path + ")" };
  };
  /**Returns error message if link is invalid */
  renderError = () => {
    if (!_.isEmpty(this.props.validLink)) {
      if (this.props.validLink.valid == false) {
        return (
          <div className="field">
            <div
              className="error-email-wrapper"
              style={this.SetBackgroundImage(RFEAlert)}
            >
              <FormattedMessage
                id={"AuthorizeLink.components.Authorize.error"}
              />
            </div>
          </div>
        );
      }
    } else {
      return " ";
    }
  };

  /**Defines and returns this.form */
  setFormApi = formApi => {
    this.formApi = formApi;
  };

  render() {
    const intl = this.props.intl;
    return (
      <React.Fragment>
        <Form id="state-form" getApi={this.setFormApi}>
          {() => (
            <div className="columns">
              <div className="column">
                <div className="card">
                  <div className="form-group">
                    <div className="card-content">
                      <div className="MLA-emailTitle">
                        <label htmlFor="email">
                          <FormattedMessage
                            id={
                              "AuthorizeLink.components.MagicLinkAuthentication.index.form"
                            }
                          />
                        </label>
                      </div>
                      <Text
                        id="input-text-email"
                        className={
                          this.formApi.getError("email")
                            ? "input is-danger"
                            : "input"
                        }
                        field="email"
                        autoFocus
                        type="text"
                        placeholder={intl.formatMessage({
                          id:
                            "AuthorizeLink.components.MagicLinkAuthentication.index.form.placeholder"
                        })}
                        validate={value => this.handleEmailValidation(value, intl)}
                        validateOnBlur
                        validateOnChange
                      />
                      {/* to show error message */}
                      {this.renderError()}

                      <div className="is-grouped">
                        <p className="help is-danger">
                          {this.formApi.getError("email")}
                        </p>
                      </div>
                      <button
                        id="button-validate"
                        className="button is-new-primary"
                        onClick={event => this.handleValidate(event)}
                      >
                        <FormattedMessage
                          id={
                            "AuthorizeLink.components.MagicLinkAuthentication.index.form.button.next"
                          }
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form>
      </React.Fragment>
    );
  }
}
MagicLinkAuthentication.propTypes = {
  /**Action general information */
  actionData: PropTypes.object,
  /**Triggers redux functions */
  dispatch: PropTypes.func,
  /**Function to decrypt key and validate */
  handleValidate: PropTypes.func,
  /**Project language and type */
  settings: PropTypes.object,
  /**Link validation info */
  validLink: PropTypes.object
};

export default connect(mapStateToProps)(injectIntl(MagicLinkAuthentication));
